export default "__VITE_ASSET__Cnw63fzk__";